export default function Card({ children, className = '', hover = true }) {
  return (
    <div
      className={`bg-surface-0 rounded-xl border border-surface-100 shadow-sm ${
        hover ? 'hover:shadow-md hover:-translate-y-1 transition-all duration-200' : ''
      } ${className}`}
    >
      {children}
    </div>
  )
}
